"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deadline = void 0;
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./deadline.css"));
var _uiKit = require("@cian/ui-kit");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Deadline = _ref => {
  let {
    deadline
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['deadline']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['title']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading4, null, deadline.title)), deadline.items.map((item, i) => {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles['row']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['key']
    }, item.title), /*#__PURE__*/React.createElement("div", {
      className: (0, _clsx.default)(styles['value'], item.hasWarning && styles['warning'])
    }, item.value));
  }));
};
exports.Deadline = Deadline;